import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const RedirectToSignIn = () => {
  const location = useLocation();
  return <Navigate to="/signin" replace state={{ from: location }} />;
};

export default RedirectToSignIn;
